import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { fmtShort } from "../lib/fmt";
import { Block } from "./Common";

export default function PanelLeaves({ members, leaveTypes, today, onChanged, version }) {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ memberId: "", from: today, to: today, type: "Cuti", note: "" });
  const load = useCallback(() => { api.get("/leaves").then((r) => setList(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load, version]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const add = async () => {
    if (!f.memberId) return toast.error("Pilih anggota");
    try {
      await api.post("/leaves", f);
      toast.success("Cuti/izin tersimpan");
      setF({ ...f, note: "" });
      load();
      onChanged();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const del = async (id) => {
    try {
      await api.delete(`/leaves/${id}`);
      load();
      onChanged();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Block title="Cuti / izin" testid="panel-leaves">
      <div className="grid grid-cols-2 gap-3">
        <div className="col-span-2">
          <label className="label" htmlFor="lv-member">Anggota</label>
          <select id="lv-member" data-testid="leave-member" className="field" value={f.memberId} onChange={set("memberId")}>
            <option value="">— Pilih —</option>
            {members.filter((m) => m.active).map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
          </select>
        </div>
        <div>
          <label className="label" htmlFor="lv-from">Dari</label>
          <input id="lv-from" data-testid="leave-from" type="date" className="field" value={f.from} onChange={set("from")} />
        </div>
        <div>
          <label className="label" htmlFor="lv-to">Sampai</label>
          <input id="lv-to" data-testid="leave-to" type="date" className="field" value={f.to} onChange={set("to")} />
        </div>
        <div>
          <label className="label" htmlFor="lv-type">Jenis</label>
          <select id="lv-type" data-testid="leave-type" className="field" value={f.type} onChange={set("type")}>
            {leaveTypes.map((t) => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label className="label" htmlFor="lv-note">Catatan</label>
          <input id="lv-note" data-testid="leave-note" className="field" value={f.note} onChange={set("note")} />
        </div>
      </div>
      <button data-testid="leave-add-button" onClick={add} className="btn-primary mt-4"><Plus size={16} /> Tambah</button>
      <div className="mt-4 max-h-72 divide-y divide-brand-line overflow-y-auto rounded-xl border border-brand-line" data-testid="leave-list">
        {list.length === 0 && <p className="p-3 text-sm text-[#7a6667]">Belum ada data cuti.</p>}
        {list.map((l) => (
          <div key={l.id} className="flex items-center justify-between gap-2 p-3 text-sm">
            <div className="min-w-0">
              <div className="font-bold">{l.memberName} <span className="font-normal text-[#7a6667]">· {l.type}</span></div>
              <div className="text-xs text-[#7a6667]">{fmtShort(l.from)} – {fmtShort(l.to)} {l.note && `· ${l.note}`}</div>
            </div>
            <button data-testid={`leave-delete-${l.id}`} onClick={() => del(l.id)} aria-label="Hapus" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-brand hover:bg-brand-tint"><Trash2 size={16} /></button>
          </div>
        ))}
      </div>
    </Block>
  );
}
